const ALLOWED_TAGS = new Set(["B", "STRONG", "I", "EM", "U", "OL", "UL", "LI", "BR", "P", "DIV"]);
const ALIGNABLE_TAGS = new Set(["P", "DIV", "LI"]);
const TEXT_ALIGN = /^text-align:\s*(left|center|right|justify)\s*;?$/i;

export const sanitizeNoticeHtml = (html) => {
  const source = String(html || "");
  if (!source.trim() || typeof DOMParser === "undefined") return "";

  const doc = new DOMParser().parseFromString(source, "text/html");
  const cleanNode = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType !== Node.ELEMENT_NODE) return;
      if (!ALLOWED_TAGS.has(child.tagName)) {
        const text = doc.createTextNode(child.textContent || "");
        child.replaceWith(text);
        return;
      }
      const align = String(child.getAttribute("style") || "").trim();
      [...child.attributes].forEach((attr) => child.removeAttribute(attr.name));
      const alignMatch = align.match(TEXT_ALIGN);
      if (alignMatch && ALIGNABLE_TAGS.has(child.tagName)) {
        child.setAttribute("style", `text-align: ${alignMatch[1].toLowerCase()}`);
      }
      cleanNode(child);
    });
  };

  cleanNode(doc.body);
  return doc.body.innerHTML;
};

export const noticeHtmlHasText = (html) =>
  String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim().length > 0;

export const isNoticeEnabled = (value) =>
  value === true || value === 1 || value === "1";
